import * as React from "react";
import { PageContainer } from "../../../../components";
import { DrupalActivitySearchBar } from "../item/DrupalActivitySearchBar";
import { AnnualCompetitionList } from "./AnnualCompetitionList";

export interface IDrupalCompetitionListPageProps {
  isCoursing: boolean;
}

export const DrupalCompetitionListPage: React.FunctionComponent<IDrupalCompetitionListPageProps> = ({ isCoursing }) => {
  const [activityId, setactivityId] = React.useState();
  return (
    <PageContainer>
      <DrupalActivitySearchBar onSelectionChanged={setactivityId} />
      <AnnualCompetitionList year={new Date().getFullYear() + 1} isCoursing={isCoursing} activityId={activityId} />
      <AnnualCompetitionList year={new Date().getFullYear()} isCoursing={isCoursing} activityId={activityId} />
    </PageContainer>
  );
};
